import { connect } from 'react-redux'
import { runOnNextTick } from 'util/functions'
import { selectIsLeftSidebarCollapsed } from 'selectors/app'
import { doFetchReportsBootstrapData } from 'actions/app'
import {
  selectIsKbsLoaded,
  selectKnowledgeBaseTotal,
} from 'subapps/kb/selectors/knowledge_bases'
import { selectPrefersShowTopNav } from 'selectors/app/selectAccountPreferences'
import { doFetchKnowledgeBases } from 'subapps/kb/actions/knowledge_bases'
import { selectIsAccountBootstrapped } from 'selectors/app/selectAccount'
import { doLayoutMounted } from '../../actions'
import {
  selectLayoutMounted,
  selectShowContent,
  selectShowEmptyState,
} from '../../selectors'

import ReportsLayout from './view'

const select = state => ({
  layoutMounted: selectLayoutMounted(state),
  isLeftSidebarCollapsed: selectIsLeftSidebarCollapsed(state),
  showEmptyState: selectShowEmptyState(state),
  showContent: selectShowContent(state),
  hasKnowledgeBases: selectKnowledgeBaseTotal(state) > 0,
  isKbsLoaded: selectIsKbsLoaded(state),
  showTopNav: selectPrefersShowTopNav(state),
  isAccountBootstrapped: selectIsAccountBootstrapped(state),
})

const perform = dispatch => ({
  onComponentDidMount: () => {
    runOnNextTick(() => {
      dispatch(doFetchReportsBootstrapData())
      dispatch(doLayoutMounted())
    })
  },
  onComponentDidUpdate: () => {
    runOnNextTick(() => {
      dispatch(doLayoutMounted())
    })
  },
  fetchKnowledgeBases: () => dispatch(doFetchKnowledgeBases()),
})

export default connect(select, perform)(ReportsLayout)
